import { getItemAttributeByIdentifier } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/AttributeSelectors';
import { AttributeIdentifiers, OptionClassificationIdentifiers, SurfaceOptionIdentifiers } from '../Enums';
import { getSelectedOptionFromClassification } from './optionClassifications';
import { attrIsOn } from './optionAttributes';

export function getOptionAttrValues(option: unknown, attr: string): string[] {
  const values = (
    getItemAttributeByIdentifier(option, attr) as { values?: Array<{ value?: unknown }> } | undefined
  )?.values;
  if (!Array.isArray(values)) return [];
  return values
    .map((v) => (v?.value === undefined || v?.value === null ? '' : String(v.value)))
    .filter(Boolean);
}

export function getSelectedMaterialThickness(configurator: {
  optionsList?: Record<string, unknown[]>;
  configuration?: { optionclassifications?: unknown };
}): string | null {
  const materialSelected = getSelectedOptionFromClassification(
    configurator.configuration?.optionclassifications,
    OptionClassificationIdentifiers.material
  );
  if (!materialSelected?.identifier) return null;

  const materialOptions = configurator.optionsList?.[OptionClassificationIdentifiers.material] || [];
  const materialOption = materialOptions.find(
    (o) => (o as { identifier?: string }).identifier === materialSelected.identifier
  );
  if (!materialOption) return null;

  return getOptionAttrValues(materialOption, AttributeIdentifiers.thickness)[0] ?? null;
}

export function filterColorOptions<T>(
  options: T[],
  filters: { surface?: string | null; thickness?: string | null }
): T[] {
  let result = options;
  const { surface, thickness } = filters;

  if (surface) {
    const isGloss = surface === SurfaceOptionIdentifiers.gloss;
    result = result.filter((option) =>
      isGloss ? !attrIsOn(option, 'matteOnly') : !attrIsOn(option, 'glossOnly')
    );
  }

  if (thickness) {
    result = result.filter((option) =>
      getOptionAttrValues(option, AttributeIdentifiers.thickness).includes(thickness)
    );
  }

  return result;
}
